import { SearchUtils } from '@spotify/confidence-core-react';
import {
  IssueFragment,
  IssueFragmentDoc,
  IssueQuery,
  IssueQueryVariables,
  useIssueSuspenseQuery,
  useOnIssueUpdatedSubscription,
  withStandardGetSuspenseHook,
} from '@spotify/confidence-graphql';

const useIssueSuspenseImpl = withStandardGetSuspenseHook<
  IssueQuery,
  IssueFragment,
  'issue',
  IssueQueryVariables
>(useIssueSuspenseQuery, 'issue');

export const useIssueSuspense: typeof useIssueSuspenseImpl = options => {
  useOnIssueUpdatedSubscription({
    variables: {
      filter: `issue.name:${SearchUtils.escapeQuery(options.name)}`,
    },
    onData: ({ client, data: result }) => {
      const issue = result.data?.issueUpdated?.issue;
      if (!issue?.__typename || !issue.name) return;
      client.cache.writeFragment({
        id: client.cache.identify(issue),
        fragment: IssueFragmentDoc,
        fragmentName: 'Issue',
        data: issue,
      });
    },
  });

  return useIssueSuspenseImpl(options);
};
